.menu {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 176px;
  padding: 6px;
}

.item {
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  gap: 8px;
  padding: 8px 12px;
  transition: background-color 0.15s;

  &:not(.isDestructive) {
    color: var(--color-foreground);

    &:hover {
      background: var(--color-secondary);
    }
  }

  &.isDestructive {
    color: var(--color-danger);

    &:hover {
      background: var(--color-danger-bg);
    }
  }
}

// Wrap the SVG in a flex container so icons of slightly different
// intrinsic metrics (StickyNote vs Copy vs Trash2) all sit on the same
// optical baseline as the label text. Without `display: inline-flex`,
// the inline SVG defaults to baseline alignment and drifts a pixel or
// two per icon — visible as a ragged left edge across the menu.
.itemIcon {
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  /* Match icon size to label cap-height so they share a center line. */
  height: 14px;
  justify-content: center;
  width: 14px;
}

.itemIcon > svg {
  display: block;
}
